import { Link, matchPath, useLocation, useNavigate } from 'react-router-dom';
import { config } from '../../config';
import { NotificationBadge } from '../notifications/NotificationBadge';
import { MeetInstruction } from '../../pages/meet/MeetInstruction';
import { RouletteInstruction } from '../../pages/roulette/RouletteInstruction';
import { FiltersCount } from '../../pages/meet/FiltersCount';
import { BalanceWidget } from './BalanceWidget';
import { openTelegramLink } from '../../utils/openLink';
import { UsersRoundIcon } from 'lucide-react';

function StreamsTopBarActions() {
  const location = useLocation();

  return (
    <div className="flex gap-[8px] ml-auto">
      <Link to={`${config.ROUTES.STREAMS.FILTERS}${location.search}`}>
        <img alt="filters" src="/icons/Button-filters.svg" className="cursor-pointer" />
      </Link>

      <Link to={config.ROUTES.NOTIFICATIONS} className="relative">
        <img alt="notifications" src="/icons/Button-notifications.svg" className="w-[44px] h-[44px] cursor-pointer" />
        <NotificationBadge />
      </Link>
    </div>
  );
}

// Кнопки вкладки «Мероприятия»: фильтры + уведомления
function EventsTopBarActions() {
  const location = useLocation();

  return (
    <div className="flex items-center gap-[8px] ml-auto">
      <Link to={`${config.ROUTES.EVENTS.FILTERS}${location.search}`}>
        <img alt="filters" src="/icons/Button-filters.svg" className="cursor-pointer" />
      </Link>

      <Link to={config.ROUTES.NOTIFICATIONS} className="relative">
        <img
          alt="notifications"
          src="/icons/Button-notifications.svg"
          className="w-[44px] h-[44px] cursor-pointer"
        />
        <NotificationBadge />
      </Link>
    </div>
  );
}

// Центрированный заголовок топбара с линией-подчёркиванием
function TopBarTitle({ children }) {
  return (
    <>
      <p className="flex-1 text-center my-auto gap-[8px] text-[18px] font-semibold font-raleway text-white -translate-x-[22px] pointer-events-none">
        {children}
      </p>
      <div className="absolute left-0 ring-0 bottom-0 h-[1px] bg-[#233636] w-full"></div>
    </>
  );
}

const configTopBar = {
  [config.ROUTES.CHATS.LIST]: {
    items: [
      () => (
        <div className="flex gap-2">
          <button
            className="bg-white/10 text-sm font-medium size-[44px] rounded-full text-[#010D0D] flex items-center justify-center"
            onClick={() => openTelegramLink('https://t.me/mytadating')}
          >
            <img src="/icons/selfhst_telegram.svg" alt="Канал" className="w-[24px] h-[24px]" />
          </button>

          <BalanceWidget />
        </div>
      ),
      () => (
        <Link to={config.ROUTES.NOTIFICATIONS} className="relative">
          <img alt="notifications" src="/icons/Button-notifications.svg" className="w-[44px] h-[44px] cursor-pointer" />
          <NotificationBadge />
        </Link>
      )
    ]
  },
  [config.ROUTES.NOTIFICATIONS]: {
    items: [
      () => (
        <Link to={config.ROUTES.MEET}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </Link>
      ),
      () => (
        <>
          <p className="flex-1 text-center my-auto gap-[8px] text-[18px] font-semibold font-raleway text-white -translate-x-[22px] pointer-events-none">
            Уведомления
          </p>
          <div className="absolute left-0 ring-0 bottom-0 h-[1px] bg-[#233636] w-full"></div>
        </>
      )
    ]
  },
  [config.ROUTES.STREAMS.LIST]: {
    items: [
      () => (
        <div className="flex gap-2">
          <button
            className="bg-white/10 text-sm font-medium size-[44px] rounded-full text-[#010D0D] flex items-center justify-center"
            onClick={() => openTelegramLink('https://t.me/mytadating')}
          >
            <img src="/icons/selfhst_telegram.svg" alt="Канал" className="w-[24px] h-[24px]" />
          </button>

          <BalanceWidget />
        </div>
      ),
      () => <StreamsTopBarActions />
    ]
  },
  [config.ROUTES.ROULETTE]: {
    items: [
      () => (
        <div className="flex gap-2">
          <button
            className="bg-white/10 text-sm font-medium size-[44px] rounded-full text-[#010D0D] flex items-center justify-center"
            onClick={() => openTelegramLink('https://t.me/mytadating')}
          >
            <img src="/icons/selfhst_telegram.svg" alt="Канал" className="w-[24px] h-[24px]" />
          </button>

          <BalanceWidget />
        </div>
      ),
      () => (
        <div className="flex gap-[8px] ml-auto">
          <RouletteInstruction />

          <Link to={config.ROUTES.NOTIFICATIONS} className="relative">
            <img
              alt="notifications"
              src="/icons/Button-notifications.svg"
              className="w-[44px] h-[44px] cursor-pointer"
            />
            <NotificationBadge />
          </Link>
        </div>
      )
    ]
  },
  [config.ROUTES.MEET]: {
    items: [
      () => (
        <div className="flex gap-2">
          <button
            className="bg-white/10 text-sm font-medium size-[44px] rounded-full text-[#010D0D] flex items-center justify-center"
            onClick={() => openTelegramLink('https://t.me/mytadating')}
          >
            <img src="/icons/selfhst_telegram.svg" alt="Канал" className="w-[24px] h-[24px]" />
          </button>

          <BalanceWidget />
        </div>
      ),
      () => (
        <div className="flex items-center gap-[8px] ml-auto">
          <FiltersCount />

          <MeetInstruction />

          <Link to={config.ROUTES.NOTIFICATIONS} className="relative">
            <img
              alt="notifications"
              src="/icons/Button-notifications.svg"
              className="w-[44px] h-[44px] cursor-pointer"
            />
            <NotificationBadge />
          </Link>
        </div>
      )
    ]
  },
  [config.ROUTES.EVENTS.LIST]: {
    items: [
      () => (
        <div className="flex gap-2">
          <button
            className="bg-white/10 text-sm font-medium size-[44px] rounded-full text-[#010D0D] flex items-center justify-center"
            onClick={() => openTelegramLink('https://t.me/mytadating')}
          >
            <img src="/icons/selfhst_telegram.svg" alt="Канал" className="w-[24px] h-[24px]" />
          </button>

          <BalanceWidget />
        </div>
      ),
      () => <EventsTopBarActions />
    ]
  },
  [config.ROUTES.EVENTS.FILTERS]: {
    items: [
      ({ navigate }) => (
        <button onClick={() => navigate(config.ROUTES.EVENTS.LIST)}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </button>
      ),
      ({ navigate }) => (
        <button
          onClick={() => navigate(config.ROUTES.EVENTS.LIST)}
          className="ml-auto text-white text-[18px] font-medium font-raleway"
        >
          Сбросить
        </button>
      )
    ]
  },
  [config.ROUTES.EVENTS.PARTICIPANTS(':id')]: {
    items: [
      ({ navigate }) => (
        <button onClick={() => navigate(-1)}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </button>
      ),
      () => <TopBarTitle>Список всех участников</TopBarTitle>
    ]
  },
  [config.ROUTES.EVENTS.INVITE(':id')]: {
    items: [
      ({ navigate }) => (
        <button onClick={() => navigate(-1)}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </button>
      ),
      () => <TopBarTitle>Выслать приглашение</TopBarTitle>
    ]
  },
  [config.ROUTES.EVENTS.DETAIL(':id')]: {
    items: [
      ({ navigate }) => (
        <button onClick={() => navigate(config.ROUTES.EVENTS.LIST)}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </button>
      )
    ]
  },
  [config.ROUTES.SYMPATHIES]: {
    items: [
      () => (
        <Link to={config.ROUTES.CHATS.LIST}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </Link>
      ),
      () => (
        <>
          <p className="flex-1 text-center my-auto gap-[8px] text-[18px] font-semibold font-raleway text-white -translate-x-[22px] pointer-events-none">
            Симпатии
          </p>
          <div className="absolute left-0 ring-0 bottom-0 h-[1px] bg-[#233636] w-full"></div>
        </>
      )
    ]
  },
  [config.ROUTES.LIKES]: {
    items: [
      () => (
        <div className="flex gap-2 w-full">
          <button
            className="bg-white/10 text-sm font-medium size-[44px] rounded-full text-[#010D0D] flex items-center justify-center"
            onClick={() => openTelegramLink('https://t.me/mytadating')}
          >
            <img src="/icons/selfhst_telegram.svg" alt="Канал" className="w-[24px] h-[24px]" />
          </button>

          <BalanceWidget />

          <Link to={config.ROUTES.NOTIFICATIONS} className="relative ml-auto">
            <img
              alt="notifications"
              src="/icons/Button-notifications.svg"
              className="w-[44px] h-[44px] cursor-pointer"
            />
            <NotificationBadge />
          </Link>
        </div>
      )
    ]
  },
  [config.ROUTES.SUBSCRIPTION.MAIN]: {
    items: [
      () => (
        <Link to={config.ROUTES.PROFILE_MENU}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </Link>
      ),
      () => <p className="flex-1 text-center my-auto gap-[8px] text-2xl text-white">Управление подпиской</p>
    ]
  },
  [config.ROUTES.PROFILE_MENU]: {
    items: [
      () => (
        <Link to={config.ROUTES.MEET}>
          <img alt="back" src="/icons/Button-close.svg" className="w-[44px] h-[44px]" />
        </Link>
      ),
      () => (
        <>
          <p className="flex-1 text-center my-auto gap-[8px] text-[18px] font-semibold font-raleway text-white -translate-x-[22px] pointer-events-none">
            Меню
          </p>
          <div className="absolute left-0 ring-0 bottom-0 h-[1px] bg-[#233636] w-full"></div>
        </>
      )
    ]
  },
  [config.ROUTES.INVITE]: {
    items: [
      () => (
        <Link to={config.ROUTES.PROFILE_MENU}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </Link>
      ),
      () => (
        <>
          <p className="flex-1 text-center my-auto gap-[8px] text-[18px] font-semibold font-raleway text-white -translate-x-[22px] pointer-events-none">
            Пригласить
          </p>
          <div className="absolute left-0 ring-0 bottom-0 h-[1px] bg-[#233636] w-full"></div>
        </>
      )
    ]
  },
  [config.ROUTES.PROFILE.DELETE]: {
    items: [
      () => (
        <Link to={config.ROUTES.PROFILE_MENU}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </Link>
      ),
      () => (
        <>
          <p className="flex-1 text-center my-auto gap-[8px] text-[18px] font-semibold font-raleway text-white -translate-x-[22px] pointer-events-none">
            Удаление аккаунта
          </p>
          <div className="absolute left-0 ring-0 bottom-0 h-[1px] bg-[#233636] w-full"></div>
        </>
      )
    ]
  },
  [config.ROUTES.GIFTS.SEND]: {
    items: [
      ({ navigate }) => (
        <button onClick={() => navigate(-1)}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </button>
      ),
      () => (
        <>
          <p className="flex-1 text-center my-auto gap-[8px] text-[18px] font-semibold font-raleway text-white -translate-x-[22px] pointer-events-none">
            Витрина подарков
          </p>
          <div className="absolute left-0 ring-0 bottom-0 h-[1px] bg-[#233636] w-full"></div>
        </>
      )
    ]
  },
  [config.ROUTES.PROFILE.EDIT]: {
    items: [
      ({ navigate }) => (
        <button onClick={() => navigate(-1)}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </button>
      ),
      () => <TopBarTitle>Мой профиль</TopBarTitle>
    ]
  },
  [config.ROUTES.PAYMENT]: {
    items: [
      ({ navigate }) => (
        <button onClick={() => navigate(-1)}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </button>
      ),
      () => <TopBarTitle>Пополнение счёта</TopBarTitle>
    ]
  },
  [config.ROUTES.MYTA_IDEA]: {
    items: [
      ({ navigate }) => (
        <button onClick={() => navigate(-1)}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </button>
      ),
      () => (
        <>
          <div className="flex-1 flex justify-center my-auto -translate-x-[22px] pointer-events-none">
            <img src="/logo1.svg" alt="MYTA" className="w-[134px]" />
          </div>
          <div className="absolute left-0 ring-0 bottom-0 h-[1px] bg-[#233636] w-full"></div>
        </>
      )
    ]
  },
  [config.ROUTES.PROFILE.CONFIRM_DELETE]: {
    items: [
      () => (
        <Link to={config.ROUTES.PROFILE.DELETE}>
          <img alt="back" src="/icons/Button-back.svg" className="w-[44px] h-[44px]" />
        </Link>
      ),
      () => <TopBarTitle>Удаление аккаунта</TopBarTitle>
    ]
  }
};

export function TopBar() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTopBarRoute = Object.keys(configTopBar).find((route) => matchPath(route, location.pathname));

  if (!activeTopBarRoute) return;

  return (
    <div className="sticky z-10 top-0 left-0 right-0 flex justify-between gap-1 w-full px-4 pt-5 pb-4 bg-[#1C3E3E]/10 backdrop-blur-xl">
      {configTopBar[activeTopBarRoute].items.map((Item, index) => (
        <Item navigate={navigate} key={index} />
      ))}
    </div>
  );
}
